import BaseApi from "api/baseApi";
import { objectToFormData } from "utils/data";
import { ADMIN_SHIFT_MANAGEMENTS, ADMIN_SHIFT_MANAGEMENTS_SHIFT_STATUS } from "../apiConstant";
import dayjs from "dayjs";

class ShiftManagementStaffApi extends BaseApi {
  getList<T>(params: { year_month: string }) {
    return this.get<T>(ADMIN_SHIFT_MANAGEMENTS+ '/shifts', params);
  }

  createOrUpdate<T>(data: any) {
    return this.post<T>(ADMIN_SHIFT_MANAGEMENTS, data);
  }

  updateLocked<T>(data: any) {
    return this.post<T>(ADMIN_SHIFT_MANAGEMENTS_SHIFT_STATUS, data);
  }

}

export default ShiftManagementStaffApi;
